import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import { getFoldersById } from '../folders/selectors';

export const getIsUploading = (state) => state.documents.isUploading;

export const getIsLoading = (state) => state.documents.isLoading;

export const getHasError = (state) => state.documents.hasError;

export const getDocumentsById = (state) => state.entities.documents;

export const getUploadPercent = (state) => state.documents.percentUpload;

export const getActiveFolderDocumentIds = (state) => state.documents.activeFolderDocumentIds;

export const getActiveDocumentId = (state) => state.documents.activeDocumentId;

export const getIsUpdateInProgress = (state) => state.documents.isUpdateInProgress;

export const getIsUpdatePasswordMismatch = (state) => state.documents.isUpdatePasswordMismatch;

export const getActiveFolderDocumentsIsLoading = (state) =>
  state.documents.activeFolderDocumentsIsLoading;

export const getActiveFolderDocuments = createSelector(
  [getDocumentsById, getActiveFolderDocumentIds],
  (documents, ids) => ids.map((id) => documents[id]),
);

export const getActiveFolderRecursiveDocumentIds = (state) =>
  state.documents.activeFolderRecursiveDocumentIds;

export const getActiveFolderRecursiveDocuments = createSelector(
  [getDocumentsById, getActiveFolderRecursiveDocumentIds],
  (documents, ids) => ids.map((id) => documents[id]),
);

export const getActiveDocument = createSelector(
  [getDocumentsById, getActiveDocumentId],
  (documents, id) => documents[id],
);

export const getBreadcrumbPathsForDocumentId = createCachedSelector(
  [getDocumentsById, getFoldersById, (state, documentId) => documentId],
  (documentsById, foldersById, documentId) => {
    const document = documentsById[documentId];
    if (!document || !document.folder || !foldersById[document.folder]) {
      return null;
    }
    const parentFolder = foldersById[document.folder];
    const pathFolders = parentFolder.pathIds.map((id) => foldersById[id] && foldersById[id]);
    return pathFolders
      .filter((folder) => !!folder)
      .map((folder) => ({
        path: folder.route,
        label: folder.name,
      }));
  },
)((documentsById, foldersById, documentId) => documentId || 'loading');
// 'loading' is only a dummy to avoid errors before all documentIds are fully loaded
